import { css } from "styled-components";

export const DisableFunctionality = css`
  opacity: 0.5;
  z-index: -1;
`;
